<template>
  <div class="component-mineMenu" :class="{ border: border }">
    <div class="menu-item" v-for="item in list" @click="handleClickItem(item)" :key="item.id">
      <div class="menu-val" :class="{ icon: item.icon }" :style="`${item.icon ? `background-image:url(${item.icon})` : ''}`">
        {{ item.icon ? '' : item.value }}
      </div>
      <div class="menu-key">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    border: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: function() {
        return []
      },
    },
  },
  methods: {
    handleClickItem(item) {
      if (item.id > -1) {
        this.$emit('clickItem', item)
      }
    },
  },
}
</script>

<style type="text/css" lang="scss" scoped>
.component-mineMenu {
  // 菜单列表
  margin-top: 0.3rem;
  position: relative;
  display: flex;
  height: 1.36rem;
  background-color: #fff;
  flex-flow: row nowrap;
  &.border {
    border-radius: 0.08rem;
  }
  .menu-item {
    position: relative;
    flex: 1;
    padding: 0.36rem 0 0;
    text-align: center;
    &:first-child::after {
      position: absolute;
      z-index: 1;
      top: 0;
      bottom: 0;
      right: -0.1rem;
      width: 0.2rem;
      background: url(../assets/images/shadow_right.png);
      background-size: 0.2rem;
      content: '';
    }
    &:not(:first-child):active {
      opacity: 0.3;
    }
    .menu-val {
      font-size: 0.26rem;
      line-height: 0.36rem;
      height: 0.36rem;
      color: #e93b3d;
      white-space: nowrap;
      &.icon {
        background-repeat: no-repeat;
        background-position: center center;
        background-size: auto 100%;
      }
    }
    .menu-key {
      font-size: 0.24rem;
      color: #666;
      line-height: 0.64rem;
    }
  }
}
</style>
